import { useRef } from 'react';
import { DECLINE_CANDIDATE } from '~/actions';
import { ICounterOfferEntity, useDeclineCandidateMutation } from '~/domain/Jobs';
import { useIsSuccess, useLoading, useToggle } from '~/hooks';

interface IUseDeclineInterview {
  professionalId: string;
}

export const useDeclineInterview = ({ professionalId }: IUseDeclineInterview) => {
  const declineCandidateMutation = useDeclineCandidateMutation();

  const selectedInterviewIdRef = useRef<string | null>(null);
  const counterOfferRef = useRef<ICounterOfferEntity | null>(null);
  const [isOpen, controls] = useToggle();

  const { isLoading: isDeclineLoading } = useLoading([DECLINE_CANDIDATE]);
  const { isSuccess, clearSuccess } = useIsSuccess([DECLINE_CANDIDATE]);

  const handleDeclineInterview = (interviewId: string, counterOffer: ICounterOfferEntity) => {
    selectedInterviewIdRef.current = interviewId;
    counterOfferRef.current = counterOffer;
    controls.setOn();
  };

  const handleConfirmDeclineInterview = () => {
    if (!selectedInterviewIdRef.current || !counterOfferRef.current) return;
    declineCandidateMutation.mutate({
      jobId: selectedInterviewIdRef.current,
      counterOfferId: counterOfferRef.current.id,
      cancellation_reason: '',
      candidateId: professionalId,
    });
  };

  const handleCloseDeclineInterview = () => {
    selectedInterviewIdRef.current = null;
    counterOfferRef.current = null;
    controls.setOff();
    clearSuccess();
  };

  return {
    isDeclineSuccess: isSuccess,
    isDeclining: isDeclineLoading || declineCandidateMutation.isPending,
    isOpen,
    selectedInterviewId: selectedInterviewIdRef.current,
    handleCloseDeclineInterview,
    handleConfirmDeclineInterview,
    handleDeclineInterview,
  };
};
